<template>
  <div id="ServiceList" class="service-list">
    <button v-for="(service, i) in services" :key="i" class="service" @click="redirectToServiceHandover(service)">
      <div v-if="service.image"  class="service-img-container">
        <img class="service-img" :src="service.image" :alt="service.title">
      </div>
      <div class="text-left service-info">
        <p v-if="service.title" class="service-title">{{ service.title }}</p>
        <p v-if="service.description" class="service-text">{{ truncatedDescription(service.description) }}</p>
        <div v-if="service.included_in_your_plan" class="tag-container">
          <svg
            width="14"
            height="14"
            viewBox="0 0 12 13"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M4.42655 1.28904C5.22049 0.236986 6.7795 0.236985 7.57345 1.28904C7.95674 1.79694 8.55433 2.08963 9.18374 2.07774C10.4875 2.0531 11.4595 3.29276 11.1458 4.58002C10.9943 5.20146 11.1419 5.85913 11.5435 6.3522C12.3753 7.37353 12.0284 8.91936 10.8433 9.47249C10.2711 9.73952 9.85755 10.2669 9.7289 10.8937C9.4624 12.1919 8.05778 12.8799 6.89365 12.2823C6.33164 11.9939 5.66836 11.9939 5.10635 12.2823C3.94222 12.8799 2.5376 12.1919 2.2711 10.8937C2.14244 10.2669 1.7289 9.73952 1.15674 9.47249C-0.0284198 8.91936 -0.375332 7.37353 0.45649 6.3522C0.858067 5.85913 1.00566 5.20146 0.8542 4.58002C0.540468 3.29276 1.5125 2.0531 2.81626 2.07774C3.44567 2.08963 4.04326 1.79694 4.42655 1.28904Z"
              fill="#009577"
            />
            <path
              d="M8.4375 5.19922L5.4375 8.19922C5.34375 8.29297 5.22656 8.33984 5.10938 8.33984C4.99219 8.33984 4.86328 8.29297 4.78125 8.19922L3.28125 6.69922C3.09375 6.51172 3.09375 6.21875 3.28125 6.03125C3.45703 5.85547 3.75 5.85547 3.9375 6.03125L5.10938 7.20312L7.78125 4.53125C7.95703 4.35547 8.25 4.35547 8.4375 4.53125C8.625 4.71875 8.625 5.01172 8.4375 5.19922Z"
              fill="white"
            />
          </svg>
          <span class="tag-text ml-2">Included with your plan</span>
        </div>
      </div>
    </button>
  </div>
</template>

<script>
import axios from "axios";
import config from "../../config/constants";
export default {
  name: "ServiceList",
  props: ['selectedCategory'],
  data() {
    return {
      services: [],
      allServices: []
    }
  },
  mounted() {
    this.getServices()
  },
  methods: {
    async getServices() {
      const payload = {
          user_id: this.$store.getters.user_id,
        }
      const res = await axios.post(config.api_env + '/application/api/u/marketplace/get-services', payload, config.options)
      if (res.data.success && res.data.services && res.data.services.length) {
        this.services = res.data.services
        this.allServices = res.data.services
      } else if (res.data.err && res.data.err.includes("3994")) {
        this.$store.dispatch("logout");
      }
    },
    redirectToServiceHandover(service) {
      this.$router.push(`/services/${service.id}`)
    },
    filterServices(category) {
      if (!category || category.title.toLowerCase() === 'all') {
        this.services = this.allServices;
      } else {
        this.services = this.allServices.filter(service =>
          service.categories.find((serviceCategory) => {
            return serviceCategory.title === category.title
          })
        );
      }
    },
    truncatedDescription(text) {
      return text.length > 65 ? text.slice(0, 65).trim() + '...' : text;
    },
  },
  watch: {
    selectedCategory(newCategory) {
      this.filterServices(newCategory);
    }
  }
}
</script>

<style lang="less">
#ServiceList {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;

  .service {
    display: flex;
    flex: 0 1 30%;
    gap: 20px;
    border: 1px solid #E0E5F5;
    box-shadow: 0px 2px 16px 0px #0000000A;
    border-radius: 8px;
    padding: 24px;
    background: none;
  }

  .service-img-container {
    flex: 0 0 auto;
    width: 80px;
    height: 80px;
    background-color: #fff;
    border-radius: 20px;
    overflow: hidden;
  }

  .service-img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    object-position: center;
  }

  .service-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 100%;
  }

  .service-title {
    font-size: 2rem;
    line-height: 2.2rem;
    color: #192550;
    margin-bottom: 4px;
  }

  .service-text {
    flex: 1 1 100%;
    font-size: 1.6rem;
    line-height: 2.4rem;
    color: rgba(25, 37, 80, 0.8);
    margin-bottom: 0;
  }

  .tag-container {
    display: flex;
    color: #009577;
    font-family: "DMSans Bold";
    font-size: 1.4rem;
    line-height: 1.6rem;
    font-weight: 700;
    margin-top: 12px;
  }

  @media screen and (max-width:848px) {
    .service {
      flex: 0 1 48%;
    }
  }

  @media screen and (max-width:672px) {
    .service {
      flex: 1 1 100%;
    }
  }
}
</style>